import type { Directive } from "vue";

const listenerSymbol = Symbol("clickOutside");

export const vClickOutside: Directive<HTMLElement & { [listenerSymbol]: (e: PointerEvent) => void }> = {
	mounted(el, binding) {
		el[listenerSymbol] = (e: PointerEvent) => {
			if (!el.contains(e.target as Node)) binding.value(e);
		};

		document.addEventListener("click", el[listenerSymbol]);
	},

	unmounted(el: any) {
		if (el[listenerSymbol]) {
			document.removeEventListener("click", el[listenerSymbol]);
		}
	},
};
